import { render, staticRenderFns } from "./AlterarMatriculaVinculada.vue?vue&type=template&id=a534aaa0"
import script from "./AlterarMatriculaVinculada.vue?vue&type=script&lang=js"
export * from "./AlterarMatriculaVinculada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports